import type { CSSProperties } from 'react';

interface Mote {
  left: string;
  delay: string;
  duration: string;
  scale: number;
  extra?: boolean;
}

const EMBERS: Mote[] = [
  { left: '12%', delay: '0s', duration: '4.8s', scale: 1 },
  { left: '28%', delay: '1.4s', duration: '5.4s', scale: 0.7 },
  { left: '46%', delay: '0.6s', duration: '4.2s', scale: 1.15 },
  { left: '63%', delay: '2.1s', duration: '5.1s', scale: 0.8 },
  { left: '78%', delay: '1.1s', duration: '4.6s', scale: 1 },
  { left: '90%', delay: '2.8s', duration: '5.6s', scale: 0.65 },
  { left: '20%', delay: '0.3s', duration: '3.9s', scale: 0.85, extra: true },
  { left: '54%', delay: '1.8s', duration: '4.4s', scale: 1.05, extra: true },
  { left: '70%', delay: '0.9s', duration: '3.6s', scale: 0.7, extra: true },
  { left: '36%', delay: '2.4s', duration: '4.9s', scale: 0.9, extra: true },
];

export function LegendaryFx({ motes }: { motes: boolean }) {
  return (
    <span className="fx fx--legendary" aria-hidden="true">
      <span className="fx__warmth" />
      <span className="fx__guilloche" />
      <span className="fx__engrave" />
      <span className="fx__enter" />
      {motes && (
        <span className="fx__embers">
          {EMBERS.map((ember, index) => (
            <i
              key={index}
              className={ember.extra ? 'is-extra' : undefined}
              style={
                {
                  '--x': ember.left,
                  '--delay': ember.delay,
                  '--time': ember.duration,
                  '--s': ember.scale,
                } as CSSProperties
              }
            />
          ))}
        </span>
      )}
    </span>
  );
}
